module.exports = __webpack_public_path__ + "static/media/No_Image_Available.8addb0cd.jpg";